/*
    © Copyright LinkHMS B.V. All rights reserved.
    * Proprietary and confidential.
    * Unauthorized copying of this file, via any medium is strictly prohibited.
*/
import { NgModule } from '@angular/core';
import { MetaLoader, MetaStaticLoader } from '@core/meta-data/meta.loader';
import { MetaModule } from '@core/meta-data/meta.module';
import { PageTitlePositioning } from '@core/meta-data/models/page-title-positioning';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

interface ILang {
  code: string;
  name: string;
  culture: string;
}

export function metaFactory(translate: TranslateService): MetaLoader {
  const envSuffix =
    environment.environment === 'local'
      ? 'Local'
      : environment.environment === 'development'
        ? 'Dev'
        : environment.environment === 'staging'
          ? 'Staging'
          : null;
  const pageTitleSeparator = ' | ';
  const applicationName = [envSuffix, 'LinkHMS'].filter(Boolean).join(pageTitleSeparator);

  return new MetaStaticLoader({
    callback: (key: string): Observable<string | Record<string, any>> =>
      translate.get(key) as Observable<string | Record<string, any>>,
    pageTitlePositioning: PageTitlePositioning.PrependPageTitle,
    pageTitleSeparator,
    applicationName,
    defaults: {
      'title': 'LinkHMS',
      'description': 'Default description',
      'og:site_name': 'LinkHMS',
      'og:type': 'website',
      'og:locale': 'en-US',
      'og:locale:alternate': [
        { code: 'en', name: 'English', culture: 'en-US' },
        { code: 'ru', name: 'Русский', culture: 'ru-RU' },
      ]
        .map((lang: ILang) => lang.culture)
        .toString(),
    },
  });
}

@NgModule({
  imports: [
    MetaModule.forRoot({
      provide: MetaLoader,
      useFactory: metaFactory,
      deps: [TranslateService],
    }),
  ],
})
export class SharedMetaModule {}
